import gql from 'graphql-tag';
import { ORDER_LINES_FRAGMENT } from './order';

/** 购物车 */
export const CART_FRAGMENT = gql`
  fragment Cart on Order {
    id
    code
    state
    active
    updatedAt
    orderPlacedAt
    lines {
      ...OrderLine
    }
    totalQuantity
    total
    shipping
    customFields {
      orderPromotionResult {
        promResult {
          orderTotalPrice
        }
      }
    }
  }
  ${ORDER_LINES_FRAGMENT}
`;
